var React = require('react');

function VolumeonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 15V1L4.25 5.05H1v5.9h3.25L9 15zm4.88-1.24a9.22 9.22 0 000-11.52l-.88.63A8 8 0 0114.8 8a8 8 0 01-1.8 5.13l.88.63zm-2.04-1.81a6.39 6.39 0 000-7.9l-.84.63A5.48 5.48 0 0112.17 8c0 1.16-.39 2.26-1.17 3.32l.84.63z","fill":"currentColor","fillRule":"nonzero"}));
}

VolumeonInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = VolumeonInline;

VolumeonInline.default = VolumeonInline;
